import React from 'react';

import {
  ClearIcon,
  LegacySwitchView,
  HourglassEmptyIcon,
  CheckCircleIcon,
} from '@gogame/components';

const ActionStatus = ({ actionId }) => (
  <LegacySwitchView activeId={`${actionId}`}>
    <LegacySwitchView.Fragment viewId={'0'}>
      <HourglassEmptyIcon
        color={'action'}
        fontSize={'small'}
        sx={{ marginRight: '4px', color: '#838383' }}
      />
    </LegacySwitchView.Fragment>
    <LegacySwitchView.Fragment viewId={'1'}>
      <CheckCircleIcon
        color={'action'}
        fontSize={'small'}
        sx={{ marginRight: '4px', color: '#38b800' }}
      />
    </LegacySwitchView.Fragment>
    <LegacySwitchView.Fragment viewId={'2'}>
      <ClearIcon
        color={'action'}
        fontSize={'small'}
        sx={{ marginRight: '4px', color: '#dd2c00' }}
      />
    </LegacySwitchView.Fragment>
  </LegacySwitchView>
);
export default ActionStatus;
